import Constants from './constants';
import moment from 'moment';

export function storeEmailAddressInSession(emailAddress) {
  sessionStorage.setItem(Constants.SessionStorageKeys.UserEmailAddress, emailAddress);
}

export function getEmailAddressFromSession() {
  return sessionStorage.getItem(Constants.SessionStorageKeys.UserEmailAddress);
}

export function getAllUrlQueryParam(query) {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams = urlParams.get(query) || "";
  return decodeURI(queryParams);
}

export function isNullUndefined(item) {
  return !item || item === undefined || item === null
  || (item.constructor === String && item === '')
  || (item.constructor === Array && item.length === 0)
  || (item.constructor === Object && Object.keys(item).length === 0);
}

export function isIOSHandheldDevice() {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
}

export function isNotSupportedBrowser() {
  return isIE11OrOlder() || isEdgeBrowser() || isIOSHandheldDevice();
}

export function getUrlQueryParam() {
  return getAllUrlQueryParam(Constants.UrlShowLink) || getAllUrlQueryParam('ShowLink');
}

export function openTechSupport(router) {
  let routeData = router.resolve({
    name: 'tech-support'
  });
  let routePath = `${window.location.origin}${routeData.location.path}`;
  window.open(routePath, '_blank');
}

/**
 * Method helps to change route, this is how we will call this method 'changeRoute.call(this)'
 * @param {*} location 
 * @param {*} onComplete 
 * @param {*} onAbort 
 */
export function changeRoute(
  location,
  onComplete = () => {},
  onAbort = () => {}
) {
  let queryParams = {
    show: this.$route.query.show
  };
  if (this.$route.query.confId) {
    queryParams.confId = this.$route.query.confId;
  }

  if (this.$route.query.streaming) {
    queryParams.streaming = this.$route.query.streaming;
  }

  this.$router.push({
    ...location,
    query: queryParams
  }, onComplete, onAbort);
}

export function changeRouteWithUniqueId(
  location,
  uniqueId,
  onComplete = () => {},
  onAbort = () => {}
) {
  this.$router.push({
    ...location,
    params: {
      uniqueId: uniqueId
    }
  }, onComplete, onAbort);
}

export function createDownloadLink(file, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    const blobObject = new Blob([file]);
    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
  } else if (isIOSHandheldDevice()) {
    let blobObject = new Blob([file], {
      type: 'text/calendar'
    });
    getCalendarContent(blobObject, fileName);
  } else {
    const url = getCalendarContent(file, fileName);
    window.URL.revokeObjectURL(url);
  }
}

export function getCalendarContent(file, fileName) {
  let link = document.createElement("a");
  let url = window.URL.createObjectURL(file);
  link.style = "display: none";
  document.body.appendChild(link);
  link.href = url;
  link.download = fileName;
  link.click();
  return url;
}

export function isIE() {
  let ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1 || ua.indexOf('Edge/') > -1;

  return is_ie;
}

export function floatLabel(elementId, elementClass, labelClass) {
  setTimeout(() => {
    let element = document.getElementById(elementId);
    let label = element.nextElementSibling;
    if (element.value) {
      element.classList.add(elementClass);
      label.classList.add(labelClass);
    }
  }, 0);
}

export function compareDates(date1, date2) {
  return moment(date1) > moment(date2);
}

export function isIE11OrOlder() {
  let ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  let is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  return is_ie;
}

export function isEdgeBrowser() {
  let ua = navigator.userAgent;
  /* MSIE used to detect old browsers and Trident used to newer ones*/
  let isEdge = ua.toLowerCase().indexOf('edge') > -1 ? true : false;
  return isEdge;
}

export function setBrowserCookie(_name, _value, _days, _path) {
  let _date = new Date();
  _date.setTime(_date.getTime() + (_days * 24 * 60 * 60 * 1000));

  let _expires = "expires=" + _date.toUTCString();
  let cookie = _name + "=" + _value + "; " + _expires;
  if(_path) {
      cookie = cookie + ";path="+_path;
  }
  document.cookie = cookie;
}

export function getBrowserCookie(_name) {
  let cookieArray = document.cookie.split(";");
    let cookieObject = {};
    for (let i = 0; i < cookieArray.length; i++) {
        let splitCookie = cookieArray[i].trim();
        splitCookie = splitCookie.split("=");
        cookieObject[splitCookie[0]] = splitCookie[1];
    }
  return cookieObject[_name];
}

// Filter to add # to EventId and PIN based on Bridge Type
export function accessCodeFormatter(value, bridgeType) {
  if(bridgeType === Constants.BridgeTypes.Compunetix) {
    return value + '#';
  }
  return value;  
}

export function GetUserDefaultLocale() {
  const lang = navigator.userLanguage || navigator.language || navigator.browserLanguage;
  let language = Constants.Languages.English;
  if (Constants.Languages.English === lang.toLowerCase()) {
    language = Constants.Languages.English;
  } else if (Constants.Languages.Chinese === lang.toLowerCase()) {
    language = Constants.Languages.Chinese;
  } else if (Constants.Languages.Japanese === lang.toLowerCase()) {
    language = Constants.Languages.Japanese;
  }
  return language;
}

export function GetPreferredLanguage() {
  const preferredLanguage = getBrowserCookie(Constants.Cookies.LanguagePreference) ? getBrowserCookie(Constants.Cookies.LanguagePreference) : GetUserDefaultLocale();
  return preferredLanguage;
}

export function IsRFN() {
  return window.location.href.includes('rfn.awstest') || window.location.href.includes('researchfn');
}

export function privacyPolicyLink() {
  return `https://www.netroadshow.com/nrs/home/${GetPreferredLanguage()}/privacy-policy.html`;
}

export function termsOfServiceLink() {
  return `https://www.netroadshow.com/nrs/home/${GetPreferredLanguage()}/terms-of-service.html`;
}
export function OpenTechSupportForm() {
  if(IsRFN()){
    window.open('/contact-researchfn/', '_blank');
  } else {
    window.open('/nrs/home/#!/contact-us/tech-support', '_blank');
  }
}

export function lightenDarkenColor(color, percent) {
  const f = parseInt(color.slice(1), 16);
  const t = percent < 0 ? 0 : 255;
  const p = percent < 0 ? percent * -1 : percent;
  const R = f >> 16;
  // eslint-disable-next-line no-mixed-operators
  const G = f >> 8 & 0x00FF;
  const B = f & 0x0000FF;
  const hash = '#';
  return hash + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}

export function skipMissingInfoPage(params) {
  const { RegistrationFields, MissingInformation } = params;
  let skipAccountTypeFields = false;
  let skipPhoneNumber = false;
  if (RegistrationFields.length) {
    RegistrationFields.forEach(val => {
      if (val.Name === 'AccountType' && val.IsDeleted) {
        skipAccountTypeFields = true;
      }
      else if (val.Name === 'PhoneNumber' && val.IsDeleted) {
        skipPhoneNumber = true;
      }
    })
  }

  const allMandatoryFieldsPresent = !MissingInformation.NoFirstName && !MissingInformation.NoLastName
    && !MissingInformation.NoCompany && !MissingInformation.NoCountry;

  const isAccountTypePresentOrNotRequired = !MissingInformation.NoAccountType || (!!MissingInformation.NoAccountType && skipAccountTypeFields);
  const isPhoneNumberPresentOrNotRequired = !MissingInformation.NoPhoneNumber || (!!MissingInformation.NoPhoneNumber && skipPhoneNumber);

  return allMandatoryFieldsPresent && isAccountTypePresentOrNotRequired && isPhoneNumberPresentOrNotRequired;
}

export function isWebBasedReplayEnabled(replayType) {
  return replayType === Constants.ReplayTypes.WebOnly ||
      replayType === Constants.ReplayTypes.WebAndPhone ||
      replayType === Constants.ReplayTypes.NrsLiveVideoAndSlides ||
      replayType === Constants.ReplayTypes.NrsLiveAudioOnly;
}

export function isPhoneBasedReplayEnabled(replayType) {
  return replayType === Constants.ReplayTypes.PhoneOnly ||
  replayType === Constants.ReplayTypes.WebAndPhone;
}

export function decodeConferenceDetails(conferenceDetailString) {
  if (!conferenceDetailString) {
    return null;
  }
  
  const BASE62 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  // eslint-disable-next-line no-undef
  let value = BigInt(0);
  let leadingZeroes = 0;

  // Process the string and count leading zeroes in a single pass
  for (let i = 0; i < conferenceDetailString.length; i++) {
    const char = conferenceDetailString[i];
    const index = BASE62.indexOf(char);

    if (index === -1) {
      throw new Error(`Invalid character '${char}'`);
    }

    // Count leading zeroes only at the beginning
    if (i === leadingZeroes && index === 0) {
      leadingZeroes++;
    }

    // eslint-disable-next-line no-undef
    value = value * BigInt(62) + BigInt(index);
  }

  // Convert to hex and ensure even length
  let hex = value.toString(16);
  if (hex.length % 2) {
    hex = '0' + hex;
  }

  // Convert hex to bytes - browser compatible approach
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }

  // Create final result with leading zeroes
  const result = new Uint8Array(leadingZeroes + bytes.length);
  result.set(bytes, leadingZeroes);

  // Convert the byte array to a UTF-8 string - unified approach for all environments
  try {
    // Use TextDecoder if available (modern browsers and Node.js)
    if (typeof TextDecoder !== 'undefined') {
      return new TextDecoder('utf-8').decode(result);
    }
  } catch (e) {
    // Fallback if TextDecoder fails
  }

  // Fallback: convert bytes to string using fromCharCode
  // This works consistently across all environments
  let str = '';
  for (let i = 0; i < result.length; i++) {
    str += String.fromCharCode(result[i]);
  }
  return str;
}
